import React from 'react';
import ContactForm from '../components/ContactForm';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="home-container">
      <section className="header-section">
        <div className="header-content">
          <div className="header-text-container">
            <h1 className="header-title">Frum Referrals</h1>
            <p className="header-subtitle">
              Your all in one platform to get referrals to the company of your choice
            </p>
            <Link to="/get-referral" className="cta-button">Get A Referral</Link>
          </div>
          <div className="header-decoration">
            <div className="floating-circle circle-1"></div>
            <div className="floating-circle circle-2"></div>
            <div className="floating-circle circle-3"></div>
          </div>
        </div>
      </section>

      <section className="process-section">
        <h2 className="process-title">How it works</h2>
        <div className="process-container">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Choose a Company</h3>
              <p>Browse our list of companies where we have a trusted frum contactand select where you'd like to be referred</p>
            </div>
          </div>
          <div className="process-connector"></div>
          
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Submit Request</h3>
              <p>Fill out a quick form with your information and we will send it to our trusted contact</p>
            </div>
          </div>
          <div className="process-connector"></div>
          
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Get Connected</h3>
              <p>Receive your referral confirmation and connect with the company</p>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section">
        <h2 className="features-title">Our Guarantee</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>Free</h3>
            <p>This service is provided free of charge Ltoeles Horabim</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔒</div>
            <h3>Private</h3>
            <p>Your information will never be shared with anyone other then the trusted contact at the companies you pick</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">✅</div>
            <h3>Vetted</h3>
            <p>Our trusted contacts have been vetted by us to ensure they are frum & reputable</p>
          </div>
        </div>
      </section>

      <section className="become-contact-section">
        <h2 className="features-title">Become a Trusted Contact</h2>
        <div className="become-contact-content">
          <div className="info-box">
            <h3>Why Become a Trusted Contact?</h3>
            <ul>
              <li>Help others in the community succeed</li>
              <li>Build meaningful connections</li>
              <li>Strengthen the frum business network</li>
              <li>Make a positive impact on people's careers</li>
            </ul>
            <p className="requirements">
              To become a trusted contact, you should:
            </p>
            <ul>
              <li>Be employed at the company you are referring people to</li>
              <li>Be in a position to make referrals</li>
            </ul>
          </div>
          <div className="form-container">
            <h3>Apply to Join Our Network</h3>
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home; 